export default __webpack_public_path__ + "static/media/menu.5eb3dae9.svg";